var exports = {
  "k": "xe533113f--28dcb7--container",
};

module.exports = exports;
